import { render } from "./ProblemDrawer.vue?vue&type=template&id=5bd74883&scoped=true&ts=true"
import script from "./ProblemDrawer.vue?vue&type=script&lang=ts"
export * from "./ProblemDrawer.vue?vue&type=script&lang=ts"

import "./ProblemDrawer.vue?vue&type=style&index=0&id=5bd74883&lang=scss&scoped=true"
import "./ProblemDrawer.vue?vue&type=style&index=1&id=5bd74883&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd74883"]])

export default __exports__